module.exports = __webpack_public_path__ + "static/media/349JamesPBrawleyDrNW_2018-06-11_162.5e94fe99.jpg";